export default __webpack_public_path__ + "static/media/logo-tgd-declivite.a205c2a9.png";